import { DataSourceAddressParseQueryProviderProps } from "./data-source-address-parse-query";

export type DataSource_AddressParse_QueryKeyType = [
  string,
  Omit<DataSourceAddressParseQueryProviderProps, "useInitialState">
];

const addressParse_baseKey = `bbnt-data-source-address-parse`;

export const DataSourceAddressParse_QueryKey = {
  addressParse: (
    desiredAddress: DataSourceAddressParseQueryProviderProps
  ): DataSource_AddressParse_QueryKeyType => {
    const baseQueryKey = addressParse_baseKey;

    const { ...desiredAddress_cleaned } = {
      ...desiredAddress,
    };

    const queryKey: DataSource_AddressParse_QueryKeyType = [
      baseQueryKey,
      desiredAddress_cleaned,
    ];

    return queryKey;
  },
};
